/**
 * DO NOT CHANGE! This file is autogenerated by "npm run roles:generate"
 * @deprecated This structure contains modified format of role names.
 * Use updated utilities from @iconik-io/shared-lib/src/redux/auth/auth.ts
 */
export type UserRoles = {
  canActAsUser: boolean;
  canAddPerson: boolean;
  canAddPlaylistItems: boolean;
  canAddProjectMembers: boolean;
  canAddPropagatingAcls: boolean;
  canAddSequenceItems: boolean;
  canAnalyzeContent: boolean;
  canApproveWithoutRequest: boolean;
  canArchiveFormats: boolean;
  canCreateAssetRelations: boolean;
  canCreateAssets: boolean;
  canCreateCollections: boolean;
  canCreateFormats: boolean;
  canCreatePlaylists: boolean;
  canCreatePortals: boolean;
  canCreatePoster: boolean;
  canCreateProjects: boolean;
  canCreateRootCollections: boolean;
  canCreateSegments: boolean;
  canCreateSequences: boolean;
  canCreateSharesToUpload: boolean;
  canCreateSubclips: boolean;
  canCreateTranscodeJobs: boolean;
  canCreateUsers: boolean;
  canDeleteAclTemplates: boolean;
  canDeleteAcls: boolean;
  canDeleteAnalysisProfiles: boolean;
  canDeleteAnalysisServiceAccounts: boolean;
  canDeleteApprovalRequest: boolean;
  canDeleteApprovalStatus: boolean;
  canDeleteApps: boolean;
  canDeleteArchivedFormats: boolean;
  canDeleteAssetRelationTypes: boolean;
  canDeleteAssetRelations: boolean;
  canDeleteAssets: boolean;
  canDeleteAssetsHistory: boolean;
  canDeleteAutomations: boolean;
  canDeleteCollections: boolean;
  canDeleteCorsHosts: boolean;
  canDeleteDiscoveryEntities: boolean;
  canDeleteExportLocations: boolean;
  canDeleteFavorites: boolean;
  canDeleteFiles: boolean;
  canDeleteFormats: boolean;
  canDeleteGroupMappings: boolean;
  canDeleteGroups: boolean;
  canDeleteIdentityProviders: boolean;
  canDeleteJobs: boolean;
  canDeleteLogsRecipients: boolean;
  canDeleteMetadataCategories: boolean;
  canDeleteMetadataFields: boolean;
  canDeleteMetadataViews: boolean;
  canDeleteNotifications: boolean;
  canDeleteObjectShares: boolean;
  canDeletePerson: boolean;
  canDeletePlaylistItems: boolean;
  canDeletePlaylists: boolean;
  canDeletePortals: boolean;
  canDeleteProjectMembers: boolean;
  canDeleteProjects: boolean;
  canDeleteProxies: boolean;
  canDeleteRoleGroups: boolean;
  canDeleteSavedSearchGroups: boolean;
  canDeleteSavedSearches: boolean;
  canDeleteSearchBackends: boolean;
  canDeleteSearchHistory: boolean;
  canDeleteSearchViews: boolean;
  canDeleteSegments: boolean;
  canDeleteSequenceItems: boolean;
  canDeleteSequences: boolean;
  canDeleteStorages: boolean;
  canDeleteTeams: boolean;
  canDeleteThemes: boolean;
  canDeleteTranscodeJobs: boolean;
  canDeleteTranscoders: boolean;
  canDeleteTranscriptions: boolean;
  canDeleteUsers: boolean;
  canDeleteVersions: boolean;
  canDeleteWebhooks: boolean;
  canEditAllGroups: boolean;
  canEditAllGroupsLegacy: boolean;
  canEditAllRoleGroups: boolean;
  canEditAllTeams: boolean;
  canEditAllUsers: boolean;
  canEditOtherUsersComments: boolean;
  canEditPerson: boolean;
  canListAllGroups: boolean;
  canListAllRoleGroups: boolean;
  canListAllTeams: boolean;
  canListAllUsers: boolean;
  canListGroupUsers: boolean;
  canListRoleGroupUsers: boolean;
  canListStorageFiles: boolean;
  canListTeamUsers: boolean;
  canManageAllShares: boolean;
  canPublish: boolean;
  canPurgeAssets: boolean;
  canPurgeCollections: boolean;
  canPurgeFiles: boolean;
  canPurgeFormats: boolean;
  canReadAclTemplates: boolean;
  canReadAcls: boolean;
  canReadAnalysisServiceAccounts: boolean;
  canReadApprovalRequest: boolean;
  canReadApps: boolean;
  canReadAssetRelations: boolean;
  canReadAssetSubtitles: boolean;
  canReadAssets: boolean;
  canReadAssetsHistory: boolean;
  canReadAutomations: boolean;
  canReadBilling: boolean;
  canReadCollections: boolean;
  canReadCorsHosts: boolean;
  canReadCustomActions: boolean;
  canReadCuttingroom: boolean;
  canReadDashboard: boolean;
  canReadDiscoveryEntities: boolean;
  canReadExportLocations: boolean;
  canReadFiles: boolean;
  canReadFormats: boolean;
  canReadGroupMappings: boolean;
  canReadGroups: boolean;
  canReadGroupsLegacy: boolean;
  canReadIdentityProviders: boolean;
  canReadInsights: boolean;
  canReadJobs: boolean;
  canReadLogsRecipients: boolean;
  canReadMetadataCategories: boolean;
  canReadMetadataFields: boolean;
  canReadMetadataValues: boolean;
  canReadMetadataViews: boolean;
  canReadNotificationSettings: boolean;
  canReadNotifications: boolean;
  canReadPerson: boolean;
  canReadPlaylists: boolean;
  canReadPortals: boolean;
  canReadPosts: boolean;
  canReadProjects: boolean;
  canReadProxies: boolean;
  canReadRoleGroups: boolean;
  canReadSavedSearches: boolean;
  canReadSearchBackends: boolean;
  canReadSearchHistory: boolean;
  canReadSearchViews: boolean;
  canReadSegments: boolean;
  canReadSequences: boolean;
  canReadShares: boolean;
  canReadStats: boolean;
  canReadStorages: boolean;
  canReadSubscriptions: boolean;
  canReadSystemDomains: boolean;
  canReadTeams: boolean;
  canReadThemes: boolean;
  canReadTranscodeJobs: boolean;
  canReadTranscoders: boolean;
  canReadTranscriptions: boolean;
  canReadTransfers: boolean;
  canReadUsers: boolean;
  canReadWebhooks: boolean;
  canReindexAssets: boolean;
  canReindexAssetsHistory: boolean;
  canReindexCollections: boolean;
  canReindexExportLocations: boolean;
  canReindexGroups: boolean;
  canReindexMetadataViews: boolean;
  canReindexPerson: boolean;
  canReindexPlaylists: boolean;
  canReindexPortals: boolean;
  canReindexProjects: boolean;
  canReindexSavedSearches: boolean;
  canReindexSegments: boolean;
  canReindexSequences: boolean;
  canReindexShares: boolean;
  canReindexStorages: boolean;
  canReindexTranscoders: boolean;
  canReindexUsers: boolean;
  canRestoreArchivedFormats: boolean;
  canRunAutomations: boolean;
  canScanBucket: boolean;
  canSearch: boolean;
  canSearchWithAi: boolean;
  canSeeAllJobs: boolean;
  canTranscribeContent: boolean;
  canTriggerFaceRecognition: boolean;
  canTriggerMetadataAiFilling: boolean;
  canUpdatePlaylistItems: boolean;
  canUpdatePlaylistItemsPosition: boolean;
  canUseAdobePanel: boolean;
  canUseMcp: boolean;
  canWriteAclTemplates: boolean;
  canWriteAcls: boolean;
  canWriteAnalysisProfiles: boolean;
  canWriteAnalysisServiceAccounts: boolean;
  canWriteApprovalRequest: boolean;
  canWriteApprovalStatus: boolean;
  canWriteApprovalStatusInBulk: boolean;
  canWriteApps: boolean;
  canWriteAssetRelationTypes: boolean;
  canWriteAssetSubtitles: boolean;
  canWriteAssets: boolean;
  canWriteAssetsHistory: boolean;
  canWriteAutomations: boolean;
  canWriteBilling: boolean;
  canWriteCollections: boolean;
  canWriteCorsHosts: boolean;
  canWriteCuttingroom: boolean;
  canWriteDiscoveryEntities: boolean;
  canWriteDrmSettings: boolean;
  canWriteExportLocations: boolean;
  canWriteExports: boolean;
  canWriteFavorites: boolean;
  canWriteFiles: boolean;
  canWriteFormats: boolean;
  canWriteGroupMappings: boolean;
  canWriteGroups: boolean;
  canWriteIdentityProviders: boolean;
  canWriteJobs: boolean;
  canWriteKeyframes: boolean;
  canWriteLogsRecipients: boolean;
  canWriteMetadataCategories: boolean;
  canWriteMetadataFields: boolean;
  canWriteMetadataValues: boolean;
  canWriteMetadataViews: boolean;
  canWritePlaylists: boolean;
  canWritePortals: boolean;
  canWriteProjects: boolean;
  canWriteProxies: boolean;
  canWriteRoleGroups: boolean;
  canWriteSavedSearchGroups: boolean;
  canWriteSavedSearches: boolean;
  canWriteSearchBackends: boolean;
  canWriteSearchViews: boolean;
  canWriteSegments: boolean;
  canWriteSequences: boolean;
  canWriteShares: boolean;
  canWriteStorages: boolean;
  canWriteSubscriptions: boolean;
  canWriteTeams: boolean;
  canWriteThemes: boolean;
  canWriteTranscodeJobs: boolean;
  canWriteTranscoders: boolean;
  canWriteTranscriptions: boolean;
  canWriteTransfers: boolean;
  canWriteUsers: boolean;
  canWriteVersions: boolean;
  canWriteWatermarkSettings: boolean;
  canWriteWebhooks: boolean;
  isStorageWorker: boolean;
  webCanCreateLinkAsset: boolean;
  webCanCreatePlaceholder: boolean;
  webCanDownloadOriginal: boolean;
  webCanDownloadProxy: boolean;
  webCanListUsers: boolean;
  webCanTopLevelUpload: boolean;
  webCanUpload: boolean;
  webCanUploadLegacy: boolean;
  webCanViewVersions: boolean;
  webEnablePosters: boolean;
};

export const rolesList = [
  'can_act_as_user',
  'can_add_person',
  'can_add_playlist_items',
  'can_add_project_members',
  'can_add_propagating_acls',
  'can_add_sequence_items',
  'can_analyze_content',
  'can_approve_without_request',
  'can_archive_formats',
  'can_create_asset_relations',
  'can_create_assets',
  'can_create_collections',
  'can_create_formats',
  'can_create_playlists',
  'can_create_portals',
  'can_create_poster',
  'can_create_projects',
  'can_create_root_collections',
  'can_create_segments',
  'can_create_sequences',
  'can_create_shares_to_upload',
  'can_create_subclips',
  'can_create_transcode_jobs',
  'can_create_users',
  'can_delete_acl_templates',
  'can_delete_acls',
  'can_delete_analysis_profiles',
  'can_delete_analysis_service_accounts',
  'can_delete_approval_request',
  'can_delete_approval_status',
  'can_delete_apps',
  'can_delete_archived_formats',
  'can_delete_asset_relation_types',
  'can_delete_asset_relations',
  'can_delete_assets',
  'can_delete_assets_history',
  'can_delete_automations',
  'can_delete_collections',
  'can_delete_cors_hosts',
  'can_delete_discovery_entities',
  'can_delete_export_locations',
  'can_delete_favorites',
  'can_delete_files',
  'can_delete_formats',
  'can_delete_group_mappings',
  'can_delete_groups',
  'can_delete_identity_providers',
  'can_delete_jobs',
  'can_delete_logs_recipients',
  'can_delete_metadata_categories',
  'can_delete_metadata_fields',
  'can_delete_metadata_views',
  'can_delete_notifications',
  'can_delete_object_shares',
  'can_delete_person',
  'can_delete_playlist_items',
  'can_delete_playlists',
  'can_delete_portals',
  'can_delete_project_members',
  'can_delete_projects',
  'can_delete_proxies',
  'can_delete_role_groups',
  'can_delete_saved_search_groups',
  'can_delete_saved_searches',
  'can_delete_search_backends',
  'can_delete_search_history',
  'can_delete_search_views',
  'can_delete_segments',
  'can_delete_sequence_items',
  'can_delete_sequences',
  'can_delete_storages',
  'can_delete_teams',
  'can_delete_themes',
  'can_delete_transcode_jobs',
  'can_delete_transcoders',
  'can_delete_transcriptions',
  'can_delete_users',
  'can_delete_versions',
  'can_delete_webhooks',
  'can_edit_all_groups',
  'can_edit_all_groups_legacy',
  'can_edit_all_role_groups',
  'can_edit_all_teams',
  'can_edit_all_users',
  'can_edit_other_users_comments',
  'can_edit_person',
  'can_list_all_groups',
  'can_list_all_role_groups',
  'can_list_all_teams',
  'can_list_all_users',
  'can_list_group_users',
  'can_list_role_group_users',
  'can_list_storage_files',
  'can_list_team_users',
  'can_manage_all_shares',
  'can_publish',
  'can_purge_assets',
  'can_purge_collections',
  'can_purge_files',
  'can_purge_formats',
  'can_read_acl_templates',
  'can_read_acls',
  'can_read_analysis_service_accounts',
  'can_read_approval_request',
  'can_read_apps',
  'can_read_asset_relations',
  'can_read_asset_subtitles',
  'can_read_assets',
  'can_read_assets_history',
  'can_read_automations',
  'can_read_billing',
  'can_read_collections',
  'can_read_cors_hosts',
  'can_read_custom_actions',
  'can_read_cuttingroom',
  'can_read_dashboard',
  'can_read_discovery_entities',
  'can_read_export_locations',
  'can_read_files',
  'can_read_formats',
  'can_read_group_mappings',
  'can_read_groups',
  'can_read_groups_legacy',
  'can_read_identity_providers',
  'can_read_insights',
  'can_read_jobs',
  'can_read_logs_recipients',
  'can_read_metadata_categories',
  'can_read_metadata_fields',
  'can_read_metadata_values',
  'can_read_metadata_views',
  'can_read_notification_settings',
  'can_read_notifications',
  'can_read_person',
  'can_read_playlists',
  'can_read_portals',
  'can_read_posts',
  'can_read_projects',
  'can_read_proxies',
  'can_read_role_groups',
  'can_read_saved_searches',
  'can_read_search_backends',
  'can_read_search_history',
  'can_read_search_views',
  'can_read_segments',
  'can_read_sequences',
  'can_read_shares',
  'can_read_stats',
  'can_read_storages',
  'can_read_subscriptions',
  'can_read_system_domains',
  'can_read_teams',
  'can_read_themes',
  'can_read_transcode_jobs',
  'can_read_transcoders',
  'can_read_transcriptions',
  'can_read_transfers',
  'can_read_users',
  'can_read_webhooks',
  'can_reindex_assets',
  'can_reindex_assets_history',
  'can_reindex_collections',
  'can_reindex_export_locations',
  'can_reindex_groups',
  'can_reindex_metadata_views',
  'can_reindex_person',
  'can_reindex_playlists',
  'can_reindex_portals',
  'can_reindex_projects',
  'can_reindex_saved_searches',
  'can_reindex_segments',
  'can_reindex_sequences',
  'can_reindex_shares',
  'can_reindex_storages',
  'can_reindex_transcoders',
  'can_reindex_users',
  'can_restore_archived_formats',
  'can_run_automations',
  'can_scan_bucket',
  'can_search',
  'can_search_with_ai',
  'can_see_all_jobs',
  'can_transcribe_content',
  'can_trigger_face_recognition',
  'can_trigger_metadata_ai_filling',
  'can_update_playlist_items',
  'can_update_playlist_items_position',
  'can_use_adobe_panel',
  'can_use_mcp',
  'can_write_acl_templates',
  'can_write_acls',
  'can_write_analysis_profiles',
  'can_write_analysis_service_accounts',
  'can_write_approval_request',
  'can_write_approval_status',
  'can_write_approval_status_in_bulk',
  'can_write_apps',
  'can_write_asset_relation_types',
  'can_write_asset_subtitles',
  'can_write_assets',
  'can_write_assets_history',
  'can_write_automations',
  'can_write_billing',
  'can_write_collections',
  'can_write_cors_hosts',
  'can_write_cuttingroom',
  'can_write_discovery_entities',
  'can_write_drm_settings',
  'can_write_export_locations',
  'can_write_exports',
  'can_write_favorites',
  'can_write_files',
  'can_write_formats',
  'can_write_group_mappings',
  'can_write_groups',
  'can_write_identity_providers',
  'can_write_jobs',
  'can_write_keyframes',
  'can_write_logs_recipients',
  'can_write_metadata_categories',
  'can_write_metadata_fields',
  'can_write_metadata_values',
  'can_write_metadata_views',
  'can_write_playlists',
  'can_write_portals',
  'can_write_projects',
  'can_write_proxies',
  'can_write_role_groups',
  'can_write_saved_search_groups',
  'can_write_saved_searches',
  'can_write_search_backends',
  'can_write_search_views',
  'can_write_segments',
  'can_write_sequences',
  'can_write_shares',
  'can_write_storages',
  'can_write_subscriptions',
  'can_write_teams',
  'can_write_themes',
  'can_write_transcode_jobs',
  'can_write_transcoders',
  'can_write_transcriptions',
  'can_write_transfers',
  'can_write_users',
  'can_write_versions',
  'can_write_watermark_settings',
  'can_write_webhooks',
  'is_storage_worker',
  'web_can_create_link_asset',
  'web_can_create_placeholder',
  'web_can_download_original',
  'web_can_download_proxy',
  'web_can_list_users',
  'web_can_top_level_upload',
  'web_can_upload',
  'web_can_upload_legacy',
  'web_can_view_versions',
  'web_enable_posters',
] as const;

export type Role = (typeof rolesList)[number];

export const allRoles: Role[] = [...rolesList];

const roleSet: ReadonlySet<string> = new Set(rolesList);

export const isRole = (value: string): value is Role => roleSet.has(value);
